import {
  AfterViewInit,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
} from "@angular/core";

import { DEFAULT_COUNT_OF_VISIBLE_FILTERS } from "./constants";
import { GroupItemDirective } from "./group-item.directive";

enum DISPLAY {
  NONE = "none",
  VISIBLE = "",
}

@Component({
  selector: "med-group-control",
  templateUrl: "./med-group-control.component.html",
  styleUrls: ["./med-group-control.component.scss"],
})
export class MedGroupControlComponent implements AfterViewInit {
  @Input() showAll = true;
  @Input() hasSwitchBtn = false;
  @Input() countOfVisible: number = DEFAULT_COUNT_OF_VISIBLE_FILTERS;

  @Output() showAllChange = new EventEmitter<boolean>();

  @ContentChildren(GroupItemDirective) children!: QueryList<GroupItemDirective>;

  get countOfHidden(): number {
    return this.children.length - this.countOfVisible;
  }

  ngAfterViewInit() {
    this._updateVisible();
    this.children.changes.subscribe(() => this._updateVisible());
  }

  onToggle() {
    this.showAll = !this.showAll;
    this._updateVisible();
    this.showAllChange.emit(this.showAll);
  }

  private _updateVisible(): void {
    this.children.forEach(({ element }, index) => {
      element.nativeElement.style.display = this.showAll || index < this.countOfVisible
        ? DISPLAY.VISIBLE : DISPLAY.NONE;
    });
  }
}

